import React from 'react';
import { MainLayout } from '../components/MainLayout';
import { SimplifiedReconciliationPage } from '../components/reconciliation/SimplifiedReconciliationPage';

export function Reconciliation() {
  return (
    <MainLayout>
      <SimplifiedReconciliationPage />
    </MainLayout>
  );
}
